const helper = require('../../helper');

const srcAccountListEl = document.getElementById('braintreeSrcAccountsList');
const srcButtonEl = document.querySelector('.js-braintree-src-button');
const accoutnListBlockEl = document.querySelector('.js-braintree-used-src-account');
const alertInfoEl = document.querySelector('.js-billing-address-info-alert');

/**
 * Sets value to data-paypal-is-hide-continue-button attribute
 * @param {boolean} value true/false
 */
function setIsHideContinueButtonAttr(value) {
    const srcContentEl = document.querySelector('.js-braintree-src-content');

    srcContentEl.setAttribute('data-paypal-is-hide-continue-button', value);
}

/**
 * Handles actions based on selected value in SRC dropdown for checkout view
 */
function srsListStateHandler() {
    const srcOptionId = srcAccountListEl.value;

    if (srcOptionId === 'newaccount') {
        if (alertInfoEl) {
            alertInfoEl.style.display = 'block';
        }

        accoutnListBlockEl.style.display = 'none';
    } else {
        srcButtonEl.style.display = 'none';

        if (alertInfoEl) {
            alertInfoEl.style.display = 'none';
        }

        helper.continueButtonToggle(false);
        setIsHideContinueButtonAttr(false);
    }
}

module.exports = {
    setIsHideContinueButtonAttr,
    srsListStateHandler
};
